export default __webpack_public_path__ + "static/media/reactC.4becd3d9.webp";